<template>
  <div>
    <!-------------------heading------------->
    <v-row class="d-flex justify-space-between" flat>
      <v-col cols="12" md="4">
        <h1 class="heading-1">Store</h1>
      </v-col>
      <v-col cols="12" md="8">
        <v-card flat class="d-flex justify-end mt-2">
          <div class="pr-4">
            <v-btn
              depressed
              outlined
              color="primary"
              class="px-7 py-5"
              @click="organizeDialog = true"
            >
              Organize
            </v-btn>
          </div>
          <div class="pr-4">
            <v-btn
              depressed
              outlined
              color="primary"
              class="py-5"
              @click="updateinvetory()"
            >
              Update Inventory
            </v-btn>
          </div>
          <v-btn
            color="primary"
            dark
            class="px-5 py-5"
            depressed
            @click="AddProductdialog = true"
            @Close="closeProduct"
          >
            + Add new Product
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
    <!--------- search and filter-------------->
    <v-row class="mt-6">
      <v-col cols="12" md="4" sm="6">
        <v-card flat style="color: #f2f3f9">
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search"
            v-model="search"
            @input="searchData()"
            single-line
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
          @click="filterDialog = true"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-icon>mdi-tune</v-icon>
              <span class="mx-1" style="letter-spacing: 1px">Filters</span>
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card>
        <!------------------------fliter diloag------------------------------------------>
        <v-dialog v-model="filterDialog" max-width="430" persistent>
          <v-card class="py-5">
            <v-card-title
              class="mb-5 d-flex justify-space-between align-center"
            >
              <div class=""><b>Filters</b></div>
              <div>
                <v-btn text depressed class="pa-0" @click="cleanFilter()">
                  <span class="primary--text" style="letter-spacing: 0px"
                    >Clean filters</span
                  >
                </v-btn>
                <v-icon class="ml-3" @click="filterDialog = false"
                  >mdi-close</v-icon
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-select
                outlined
                v-model="filterObj.Category"
                :items="GetProductCategories"
                item-text="Category.CategoryName"
                item-value="Category.Id"
                dense
                hide-details
                label="By Category "
                persistent-hint
                :menu-props="{ maxHeight: '400' }"
              ></v-select>
              <v-select
                outlined
                class="my-5"
                v-model="filterObj.Stock"
                :items="filterStockList"
                dense
                :menu-props="{ maxHeight: '400' }"
                hide-details
                label="By Stock"
                persistent-hint
              ></v-select>

              <v-select
                outlined
                v-model="filterObj.Discount"
                :items="filterDiscountList"
                dense
                item-text="label"
                item-value="value"
                :menu-props="{ maxHeight: '400' }"
                hide-details
                label="By Discount"
                persistent-hint
              ></v-select>
              <v-select
                outlined
                class="my-5"
                v-model="filterObj.Visibility"
                :items="filterShowhideList"
                :menu-props="{ maxHeight: '400' }"
                dense
                hide-details
                label="By Show/Hide"
                persistent-hint
              ></v-select>

              <!---------------------Type-modalitiy model filter-------------------------------->
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#646464"
                outlined
                depressed
                class="px-5"
                text
                @click="filterDialog = false"
              >
                <span class=""> Cancel </span>
              </v-btn>
              <v-btn
                color="primary"
                class="px-8 ml-2"
                @click="sendFilters()"
                depressed
              >
                <span class=""> Save Filters </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetProducts"
        :page.sync="page"
        item-key="Id"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b class="index_index_text">
            {{ index + displayedItemsPerPage * (page - 1) + 1 }}
          </b>
        </template>

        <!-- <template v-slot:[`item.name`]="{ item }">
          <div style="display: flex; align-items: center" class="px-2 pa-2">
           <v-img :src="imageUrl(item.CoverImage)" alt="John"  />
            <div>
              <p class="mb-0 mx-3 index-head">
                {{ item.ProductName }}
              </p>
            </div>
          </div>
        </template> -->
        <template v-slot:[`item.name`]="{ item }">
          <div style="display: flex; align-items: center" class="py-2">
            <v-avatar v-if="item.CoverImage" tile>
              <img :src="item.CoverImage" alt="John" />
            </v-avatar>
            <v-avatar tile v-else>
              <!-- <v-icon>mdi-account-off-outline</v-icon> -->
               <img src="../../assets/images/default-img2.jpg" />
            </v-avatar>
            <div>
              <p class="mb-0 mx-3 index-head">
                {{ item.ProductName }}
              </p>
            </div>
          </div>
        </template>
        <template v-slot:[`item.Category`]="{ item }">
          <span class="index_head_text">
            {{ item.Category?.CategoryName }}
          </span>
        </template>
        <template v-slot:[`item.Stock`]="{ item }">
          <span class="index_head_text"> {{ item.Stock }} </span>
        </template>
        <!-- <template v-slot:[`item.status`]="{ item }">
          <span class="index_head_text">
            <v-chip id="chip" small :class="`${item.status}`">
              {{ item.status }}</v-chip
            >
          </span>
        </template> -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item.Id)">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="addModel(item)"
                >
                  <v-icon color="#646464">mdi-pin-outline</v-icon>
                  <span class="ml-4 text_stylee action_dialog">Add Stock</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="historystock(item)"
                >
                  <v-icon color="#646464">mdi-open-in-new</v-icon>
                  <span class="ml-4 text_stylee action_dialog"
                    >Stock History</span
                  >
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="edit(item)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_stylee action_dialog">Edit</span>
                </v-btn>
              </v-list>

              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="SetDeleteModel(item.Id)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_stylee action_dialog">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPageChange"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination
    ></v-card>
    <!--------------------------- Add Product Dialog-------------------------->
    <v-dialog
      v-model="AddProductdialog"
      @click:outside="closeDialog"
      persistent
      max-width="720"
    >
      <v-card v-if="AddProductdialog">
        <div>
          <addproduct :addCouponDialog="add_dialog" @close="close"></addproduct>
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------  End Add Product Dialog-------------------------->
    <v-dialog
      v-model="editProductdialog"
      @click:outside="closeDialog"
      persistent
      max-width="720"
    >
      <v-card v-if="editProductdialog">
        <div>
          <addproduct
            :addCouponDialog="edit_dialog"
            @close="close"
            :editData="EditId"
            imgShow="true"
          ></addproduct>
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------  Start Inventory Dialog-------------------------->
    <v-dialog
      v-model="updateinvetorydialog"
      @click:outside="closeDialog"
      persistent
      max-width="800"
    >
      <v-card v-if="updateinvetorydialog">
        <div>
          <upadateinventory :productList="GetProducts" @close="close" />
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------  End update inventory Dialog-------------------------->
    <!---------------------------  start add stock Dialog-------------------------->
    <v-dialog
      v-model="addstockdialog"
      @click:outside="closeDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <div>
          <div class="pa-6">
            <div class="px-5">
              <span class="text-head">Add Stock </span>
              <div class="mt-4">
                <span class="text-16">{{ stockarray.ProductName }} </span>
              </div>
              <div class="mt-4">
                <span class="text-16"
                  >Date:
                  {{
                    stockarray.CreatedDate == null
                      ? new Date().toISOString().split("T")[0]
                      : stockarray.CreatedDate.split("T")[0]
                  }}
                </span>
              </div>
              <div class="mt-2">
                <div class="mb-2">
                  <span class="text-16"
                    >Quantity of stock added:{{ stockarray.Stock }}
                  </span>
                </div>
                <v-text-field
                  class="text-area pt-1"
                  single-line
                  hide-details
                  dense
                  outlined
                  v-model="formData.Stock"
                  value="0"
                  background-color="#F6F8FC"
                >
                </v-text-field>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-end mx-10 py-5">
          <v-btn
            depressed
            text
            color="#A1A1A6"
            class="px-5 pr-5"
            @click="addstockdialog = false"
          >
            Cancel
          </v-btn>
          <v-btn depressed color="primary" class="px-10" @click="savestock()">
            SAVE
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------  end add stock Dialog-------------------------->
    <!---------------------------  stock history Dialog-------------------------->
    <v-dialog
      v-model="stockhistorydialog"
      @click:outside="closeDialog"
      persistent
      max-width="700"
    >
      <v-card>
        <div class="px-8 pt-8 d-flex justify-space-between">
          <div class="d-flex justify-start">
            <span class="text-head">Stock History </span>
          </div>
          <div class="d-flex justify-end">
            <v-icon @click="stockhistorydialog = false">mdi-close</v-icon>
          </div>
        </div>
        <div>
          <stockhistory :stockhistoryarray="stockhistoryarray" />
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------  end stock history Dialog-------------------------->
    <v-dialog v-model="organizeDialog" persistent max-width="660">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <div class="d-flex align-center">
            <span class="h5 mb-1">Organize</span>
            <v-dialog v-model="newcategorydialog" persistent max-width="450">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style-main"
                  @click="SuccessToast = false"
                >
                  + Add new Category
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="pa-5 d-flex justify-space-between">
                  <span class="text_style">New Category</span>
                  <v-icon @click="newcategorydialog = false">mdi-close</v-icon>
                </v-card-title>
                <v-card color="#F6F8FC" flat class="py-2 px-3 pa-5">
                  <v-text-field
                    class="pt-3"
                    label="Name Category"
                    required
                    v-model="$v.formData.CategoryName.$model"
                    hide-details=""
                  ></v-text-field>
                  <div
                    class="red--text pl-2"
                    v-if="$v.formData.CategoryName.$error"
                  >
                    Category Name is required
                  </div>
                </v-card>
                <v-card-actions class="pb-8 pt-8">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="px-5 py-5"
                    text
                    @click="newcategorydialog = false"
                  >
                    <span style="color: #606162"> Cancel</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="saveCategory()"
                    class="px-14"
                    :disabled="btnloader"
                    depressed
                  >
                    <v-progress-circular
                      indeterminate
                      size="20"
                      class="px-5"
                      color="white"
                      v-if="btnloader"
                    ></v-progress-circular>
                    <span v-else class="text_buton">Save</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-icon @click="organizeDialog = false">mdi-close</v-icon>
        </div>

        <organizestore
          :organizeDialog="organizeDialog"
          @close="close"
        ></organizestore>
      </v-card>
    </v-dialog>
    <!--------------------------- Delete Dialog-------------------------->
    <v-dialog v-model="Dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DdialogClose()">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteStore">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------------------------- End Delete Dialog-------------------------->
  </div>
</template>

<script>
import Addproduct from "../../components/Storeview/Addproduct.vue";
//import Addstock from "../../components/Storeview/addstock.vue";
import Stockhistory from "../../components/Storeview/stockhistory.vue";
import organizestore from "../../components/Storeview/organizestore.vue";
import Upadateinventory from "../../components/Storeview/upadateinventory.vue";
// import Editproduct from "../../components/Storeview/editproduct.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Addproduct,
    Upadateinventory,
    //Addstock,
    Stockhistory,
    organizestore,
    // Editproduct,
  },
  data() {
    return {
      totalRecords: null,
      filterObj: {},
      btnloader: false,
      add_dialog: false,
      edit_dialog: false,
      organizeDialog: false,
      newcategorydialog: false,
      stockhistorydialog: false,
      addstockdialog: false,
      AddProductdialog: false,
      editProductdialog: false,
      EditId: 0,
      updateinvetorydialog: false,
      Dialog: false,
      tableLoader: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      Permission: {},
      isPlaying: false,
      ispin: true,
      search: "",
      filter: "",
      CategoryName: "",
      DeleteId: 0,
      filterItem: [
        {
          text: "Category",
        },
        {
          text: "Stock",
        },
        {
          text: "Discount",
        },
        {
          text: "Show/Hide",
        },
      ],
      headers: [
        { text: "#", value: "index" },
        { text: "Product", value: "name" },
        { text: "Category", value: "Category" },
        { text: "Discount", value: "Discounted" },
        { text: "Stock", value: "Stock" },
        { text: "", value: "actions", sortable: false },
      ],
      stockhistoryarray: [],
      filterCategory: [],
      filterCategoryList: ["Study Group", "Public Talk", "Expo", "Other Event"],
      filterStock: [],
      filterStockList: ["0", "1-15", "Over 15"],
      filterDiscount: [],
      filterDiscountList: [
        { label: "True", value: true },
        { label: "False", value: false },
      ],
      filtersArray: [],
      stockarray: [],
      filterShowhide: [],
      filterShowhideList: ["Visible", "Invisible"],
      filterDialog: false,
      formData: {
        CategoryName: "",
        Stock: "",
      },
    };
  },
  validations: {
    formData: {
      CategoryName: { required },
      Stock: { required },
    },
  },
  mounted() {
    this.fetchData();
    this.$store.dispatch("GetProductCategories");
    // this.$store.dispatch("GetStockHistorty", this.stockhistoryarray.Id);
    this.tableLoader = true;
    // setTimeout(() => {
    //   this.GetProducts, (this.tableLoader = true);
    // }, 1500);
  },
  computed: {
    ...mapGetters([
      "GetLoggedInUser",
      "GetProductCategories",
      "GetProducts",
      "GetStockHistorty",
      "GetSelectedRelatedStores",
      "GetStoreById",
    ]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetProducts.length
        : this.itemsPerPage;
    },
  },
  methods: {
    handleItemPerPageChange() {
      this.page = 1;
      this.fetchData();
    },
    sendFilters() {
      this.filtersArray = [];
      if (this.filterObj.Category) {
        this.filtersArray.push({
          Key: "Category",
          Value: this.filterObj.Category,
        });
      }
      if (this.filterObj.Stock) {
        this.filtersArray.push({
          Key: "Stock",
          Value: this.filterObj.Stock,
        });
      }
      if (this.filterObj.Discount == true || this.filterObj.Discount == false) {
        this.filtersArray.push({
          Key: "Discount",
          Value: this.filterObj.Discount,
        });
      }
      if (this.filterObj.Visibility) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterObj.Visibility,
        });
      }
      this.page = 1;
      this.fetchData();
    },
    closeProduct() {
      this.AddProductdialog = false;
      this.EditId = 0;
      this.fetchData();
    },
    searchData(){
      this.page = 1;
      this.fetchData()
    },
    updateinvetory() {
      this.updateinvetorydialog = true;
      this.$store.dispatch("GetProducts", this.stockinevnotryarray).then(() => {
        this.tableLoader = false;
      });
    },

    fetchData() {
      const obj = {
        search: this.search,
        // page: this.filtersArray? 1: this.page,
        page: this.page,
        pageSize: this.itemsPerPage,
        filters: JSON.stringify(this.filtersArray),
      };
      this.tableLoader = true;
      this.$store.dispatch("GetProducts", obj).then((res) => {
        this.totalRecords = res.TotalRecords;
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
        this.filterDialog = false;
      });
    },
    imageUrl(data) {
      // return data ? process.env.VUE_APP_IMG_URL + data : "";
      return data ? data : "";
    },
    saveCategory() {
      this.$v.$touch();
      if (this.$v.formData.CategoryName.$invalid) {
        console.log("error");
      } else {
        var obj = {
          CategoryName: this.formData.CategoryName,
          UserId: this.GetLoggedInUser.Id,
        };
        this.btnloader = true;
        this.$store.dispatch("AddStoreProductCategory", obj).then((res) => {
          if (res.Status) {
            this.btnloader = false;
            this.newcategorydialog = false;
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Added Category Successfully",
              showConfirmButton: false,
              timer: 2500,
            });
            this.$store.dispatch("GetProductCategories");
          }
        });
        console.log(obj);
      }
    },
    savestock() {
      var obj = {
        Stock: this.formData.Stock,
        ProductId: this.stockarray.Id,
      };
      this.$store.dispatch("AddStoreStock", obj).then((res) => {
        if (res.Status) {
          this.addstockdialog = false;
          this.fetchData();
          this.formData.Stock = "";
        }
      });
      console.log(obj);
    },
    cleanFilter() {
      // this.filterCategory = null;
      // this.filterStock = null;
      // this.filterDiscount = null;
      // this.filterShowhide = null;
      this.filterObj = {};
    },
    edit(data) {
      this.EditId = data;
      this.editProductdialog = true;
    },
    close() {
      this.organizeDialog = false;
      this.AddProductdialog = false;
      this.editProductdialog = false;
      this.updateinvetorydialog = false;
      this.fetchData();
    },
    editProduct(obj) {
      this.$store.dispatch("GetStoreById", { Id: obj.Id, isWebApp: true });
      this.editProductdialog = true;
    },
    closeDialog() {
      this.value = false;
    },
    toggleIsPlaying(obj) {
      this.$store.dispatch("ToggleStoreVisibility", obj).then(() => {
        this.fetchData();
      });
    },
    toggleIsPin(obj) {
      this.GetProducts = this.GetProducts.map((e) => {
        if (e.index === obj) {
          e.ispin = !e.ispin;

          return e;
        }
        return e;
      });

      this.ispin = !this.ispin;
    },
    DdialogClose() {
      this.Dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    addModel(item) {
      this.stockarray = item;
      const obj = {
        page: 1,
        pageSize: "All",
        ProductId: item.Id,
      };
      this.$store.dispatch("GetProducts", obj).then((res) => {
        console.log(res);
      });

      this.addstockdialog = true;
    },
    historystock(item) {
      this.stockhistoryarray = item;
      this.stockhistorydialog = true;
      this.tableLoader = true;
      this.$store
        .dispatch("GetStockHistorty", this.stockhistoryarray.Id)
        .then(() => {
          this.tableLoader = false;
        });
    },
    SetDeleteModel(Id) {
      this.DeleteId = Id;
      this.Dialog = true;
    },
    DeleteStore() {
      this.btnloader=true;
      this.$store.dispatch("DeleteStore", this.DeleteId).then((res) => {
        if (res.Status) {
          this.Dialog = false;
          this.btnloader=false;
          this.fetchData();
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.red--text {
  font-size: 14px;
}

.text-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #222222;
}

.text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;

  color: rgba(34, 34, 34, 0.87);
}

.index-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #222222;
}

.index_head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}

.v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px;
}

.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}

.text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 18px;

  color: #222222;
}

.text_style-main {
  text-transform: none;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #0071bd;
}

.text_stylee {
  text-transform: none;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;

  color: rgba(34, 34, 34, 0.87);
}

.text-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #222222;
}

.text-16 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #222222;
}

.text-area {
  background-color: #f6f8fc;
}

.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
